import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApplyGigComponent } from '../../../components/apply-gig/apply-gig';
import { FeatureSkillsComponent } from '../../../components/feature-skills/feature-skills';
import { FooterComponent } from '../../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../../components/header-desktop/header-desktop';
import { HeartButtonComponent } from '../../../components/heart-button/heart-button';
import { SlugifyPipe } from '../../../components/slugify.pipe';
import { TypePipe } from '../../../components/type.pipe';
import { YoutubePlayerComponent } from '../../../components/youtube-player/youtube-player';
import { AuthService } from '../../../core/auth.service';
import { GigService } from '../../../core/gig.service';
import { globals } from '../../../../environments/globals';
import { environment } from '../../../../environments/environment';

@Component({
    imports: [CommonModule, ApplyGigComponent, FeatureSkillsComponent, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, HeartButtonComponent, SlugifyPipe, TypePipe, YoutubePlayerComponent],
    selector: 'app-detail',
    styleUrls: ['./detail.page.scss'],
    templateUrl: './detail.page.html'
})
export class DetailPage implements OnInit {
  bucketURL: string = environment.firebase.bucketURL;
  slug: any;
  gig: any;
  directory: any = globals.directory;
  directory_data: any;
  isApply: boolean = false;
  text: any;
  constructor(
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    public auth: AuthService,
    private gs: GigService,
    private metaService: Meta,
    private route: ActivatedRoute,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.slug = this.route.snapshot.paramMap.get('slug');
    this.gs.gigDetails(this.slug).subscribe((data: any[]) => {
      this.gig = data[0];
      if(this.gig.country) {
        this.directory_data = this.directory[this.gig.country];
        this.titleService.setTitle(this.gig.title + ' | ' + (this.gig.location=='remote' ? 'Remote' : 'Onsite ' + this.gig.suburb + ' ' + this.gig.city) + ' ' + this.directory_data.name);
        this.metaService.updateTag(
          { name: 'description', property: 'og:description', content: this.gig.title + ' | ' + (this.gig.location=='remote' ? 'Remote - Work from Anywhere' : 'Onsite ' + this.gig.suburb + ' ' + this.gig.city) + ' ' + this.directory_data.name + ' | ' + this.gig.overview }
        )
        this.createStructuredData();
      }
    })
  }

  createStructuredData() {
    if (isPlatformBrowser(this.platformId)) {
      const script = <HTMLScriptElement> this.doc.head.querySelector("script[type='application/ld+json']")
      || this.doc.head.appendChild(this.doc.createElement("script"));
      
      if(this.gig) {
        this.text = {
          "@context": "https://schema.org",
          "@type" : "JobPosting",
          "title" : this.gig.title,
          "industry" : this.gig.grouping,
          "description" : this.gig.description,
          "datePosted" : new Date(this.gig.publish),
          "validThrough" : new Date(this.gig.unpublish),
          "employmentType" : "OTHER", // FULL_TIME, PART_TIME, CONTRACTOR, TEMPORARY, INTERN, VOLUNTEER, PER_DIEM, OTHER 
          "hiringOrganization" : {
            "@type" : "Organization",
            "name" : this.gig.alias,
          },
          "baseSalary": {
            "@type": "MonetaryAmount",
            "currency": this.gig.currency.toUpperCase(),
            "value": {
              "@type": "QuantitativeValue",
              "value": this.gig.total,        
              "unitText": this.gig.total < 1000 ? "DAY" : "WEEK" // HOUR, DAY, WEEK, MONTH, YEAR
            }
          }
        }
        if(this.gig.location == 'onsite') {
          this.text.jobLocation = {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": this.gig.suburb,
              "addressLocality": this.gig.city,
              "addressRegion": this.gig.region,
              "addressCountry": this.gig.country
            }
          }
        } else {
          this.text.jobLocationType = "TELECOMMUTE";
          this.text.applicantLocationRequirements = {
            "@type": "Country",
            "name": "GLOBAL"
          };
        }
      }

      script.type = "application/ld+json";
      script.text = JSON.stringify(this.text);
    }
  }
}
